import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router';

export default [
  <Route
    key="/business/campaign/"
    exact
    path="/business/campaign/:feature"
    component={AsyncPage}
  />,
];
